import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _6a3c0b80 = () => interopDefault(import('../pages/about.vue' /* webpackChunkName: "pages/about" */))
const _ff395b7c = () => interopDefault(import('../pages/cgs.vue' /* webpackChunkName: "pages/cgs" */))
const _6438005a = () => interopDefault(import('../pages/contact.vue' /* webpackChunkName: "pages/contact" */))
const _34e481d2 = () => interopDefault(import('../pages/draft/index.vue' /* webpackChunkName: "pages/draft/index" */))
const _4f708d88 = () => interopDefault(import('../pages/fixture.vue' /* webpackChunkName: "pages/fixture" */))
const _52fc3cf6 = () => interopDefault(import('../pages/jobs/index.vue' /* webpackChunkName: "pages/jobs/index" */))
const _2f266fc8 = () => interopDefault(import('../pages/parameter.vue' /* webpackChunkName: "pages/parameter" */))
const _a079e7f0 = () => interopDefault(import('../pages/partners.vue' /* webpackChunkName: "pages/partners" */))
const _55f0599e = () => interopDefault(import('../pages/purge.vue' /* webpackChunkName: "pages/purge" */))
const _70232c14 = () => interopDefault(import('../pages/reset-password.vue' /* webpackChunkName: "pages/reset-password" */))
const _e89e220c = () => interopDefault(import('../pages/sandbox.vue' /* webpackChunkName: "pages/sandbox" */))
const _f7d0395e = () => interopDefault(import('../pages/storybook.vue' /* webpackChunkName: "pages/storybook" */))
const _0be832ef = () => interopDefault(import('../pages/test.vue' /* webpackChunkName: "pages/test" */))
const _6989f3d6 = () => interopDefault(import('../pages/welcome.vue' /* webpackChunkName: "pages/welcome" */))
const _6c223da6 = () => interopDefault(import('../pages/agency/favorites/index.vue' /* webpackChunkName: "pages/agency/favorites/index" */))
const _612b1f57 = () => interopDefault(import('../pages/band/dashboard.vue' /* webpackChunkName: "pages/band/dashboard" */))
const _eb73840a = () => interopDefault(import('../pages/band/homepage.vue' /* webpackChunkName: "pages/band/homepage" */))
const _5cfefc68 = () => interopDefault(import('../pages/band/onboarding.vue' /* webpackChunkName: "pages/band/onboarding" */))
const _743a55ec = () => interopDefault(import('../pages/band/parameter.vue' /* webpackChunkName: "pages/band/parameter" */))
const _0069f190 = () => interopDefault(import('../pages/band/payin.vue' /* webpackChunkName: "pages/band/payin" */))
const _02eb102f = () => interopDefault(import('../pages/band/profile/index.vue' /* webpackChunkName: "pages/band/profile/index" */))
const _4b3f1c06 = () => interopDefault(import('../pages/band/sendtrack.vue' /* webpackChunkName: "pages/band/sendtrack" */))
const _516e9fc6 = () => interopDefault(import('../pages/band/shop/index.vue' /* webpackChunkName: "pages/band/shop/index" */))
const _15ee0bb0 = () => interopDefault(import('../pages/band/signup/index.vue' /* webpackChunkName: "pages/band/signup/index" */))
const _10b09b0a = () => interopDefault(import('../pages/draft/influencers.vue' /* webpackChunkName: "pages/draft/influencers" */))
const _1582f150 = () => interopDefault(import('../pages/influencer/activate.vue' /* webpackChunkName: "pages/influencer/activate" */))
const _04f99166 = () => interopDefault(import('../pages/influencer/cashout.vue' /* webpackChunkName: "pages/influencer/cashout" */))
const _2a72ab7f = () => interopDefault(import('../pages/influencer/dashboard.vue' /* webpackChunkName: "pages/influencer/dashboard" */))
const _3d81e214 = () => interopDefault(import('../pages/influencer/parameter.vue' /* webpackChunkName: "pages/influencer/parameter" */))
const _f07f6f52 = () => interopDefault(import('../pages/influencer/profile/index.vue' /* webpackChunkName: "pages/influencer/profile/index" */))
const _12181d00 = () => interopDefault(import('../pages/influencer/signup/index.vue' /* webpackChunkName: "pages/influencer/signup/index" */))
const _45a97f2c = () => interopDefault(import('../pages/influencer/widget/index.vue' /* webpackChunkName: "pages/influencer/widget/index" */))
const _6bd70cbb = () => interopDefault(import('../pages/payin/failure.vue' /* webpackChunkName: "pages/payin/failure" */))
const _fba97f22 = () => interopDefault(import('../pages/band/profile/create.vue' /* webpackChunkName: "pages/band/profile/create" */))
const _644a5722 = () => interopDefault(import('../pages/band/profile/select.vue' /* webpackChunkName: "pages/band/profile/select" */))
const _79b956fa = () => interopDefault(import('../pages/band/shop/finalized.vue' /* webpackChunkName: "pages/band/shop/finalized" */))
const _71b0a906 = () => interopDefault(import('../pages/band/signup/discovery.vue' /* webpackChunkName: "pages/band/signup/discovery" */))
const _878ad150 = () => interopDefault(import('../pages/influencer/list/all/index.vue' /* webpackChunkName: "pages/influencer/list/all/index" */))
const _18fca4fc = () => interopDefault(import('../pages/influencer/list/fans.vue' /* webpackChunkName: "pages/influencer/list/fans" */))
const _ada1b23a = () => interopDefault(import('../pages/influencer/list/new-arrivals.vue' /* webpackChunkName: "pages/influencer/list/new-arrivals" */))
const _dd263866 = () => interopDefault(import('../pages/influencer/list/popular.vue' /* webpackChunkName: "pages/influencer/list/popular" */))
const _ee25a9aa = () => interopDefault(import('../pages/payin/paypal/retry.vue' /* webpackChunkName: "pages/payin/paypal/retry" */))
const _fd41310e = () => interopDefault(import('../pages/spotify/share/track.vue' /* webpackChunkName: "pages/spotify/share/track" */))
const _1fa56a56 = () => interopDefault(import('../pages/agency/favorites/_id.vue' /* webpackChunkName: "pages/agency/favorites/_id" */))
const _0735ec2a = () => interopDefault(import('../pages/band/profile/_slug/index.vue' /* webpackChunkName: "pages/band/profile/_slug/index" */))
const _793a6652 = () => interopDefault(import('../pages/influencer/profile/_slug/index.vue' /* webpackChunkName: "pages/influencer/profile/_slug/index" */))
const _43f2dde4 = () => interopDefault(import('../pages/influencer/widget/_slug.vue' /* webpackChunkName: "pages/influencer/widget/_slug" */))
const _16e309e2 = () => interopDefault(import('../pages/band/profile/_slug/edit.vue' /* webpackChunkName: "pages/band/profile/_slug/edit" */))
const _22d2aaba = () => interopDefault(import('../pages/influencer/profile/_slug/edit.vue' /* webpackChunkName: "pages/influencer/profile/_slug/edit" */))
const _93b74770 = () => interopDefault(import('../pages/influencer/profile/_slug/preview.vue' /* webpackChunkName: "pages/influencer/profile/_slug/preview" */))
const _52b37682 = () => interopDefault(import('../pages/draft/_id/index.vue' /* webpackChunkName: "pages/draft/_id/index" */))
const _217df644 = () => interopDefault(import('../pages/jobs/_id.vue' /* webpackChunkName: "pages/jobs/_id" */))
const _0afc6fb6 = () => interopDefault(import('../pages/draft/_id/finalized.vue' /* webpackChunkName: "pages/draft/_id/finalized" */))
const _2a141fa9 = () => interopDefault(import('../pages/draft/_id/influencers/index.vue' /* webpackChunkName: "pages/draft/_id/influencers/index" */))
const _b4337a68 = () => interopDefault(import('../pages/draft/_id/messages.vue' /* webpackChunkName: "pages/draft/_id/messages" */))
const _5a3bcf12 = () => interopDefault(import('../pages/draft/_id/post3ds.vue' /* webpackChunkName: "pages/draft/_id/post3ds" */))
const _b3f32022 = () => interopDefault(import('../pages/draft/_id/recap.vue' /* webpackChunkName: "pages/draft/_id/recap" */))
const _7ed2063c = () => interopDefault(import('../pages/draft/_id/selection.vue' /* webpackChunkName: "pages/draft/_id/selection" */))
const _a3554b0a = () => interopDefault(import('../pages/draft/_id/track.vue' /* webpackChunkName: "pages/draft/_id/track" */))
const _52cd815a = () => interopDefault(import('../pages/draft/_id/influencers/loading.vue' /* webpackChunkName: "pages/draft/_id/influencers/loading" */))
const _0c1d5bc9 = () => interopDefault(import('../pages/draft/_id/favorites/_bucket_id.vue' /* webpackChunkName: "pages/draft/_id/favorites/_bucket_id" */))
const _ec183376 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _f1fbed7a = () => interopDefault(import('../pages/_lang/index.vue' /* webpackChunkName: "pages/_lang/index" */))
const _674a2e7e = () => interopDefault(import('../pages/_lang/about.vue' /* webpackChunkName: "pages/_lang/about" */))
const _91d86200 = () => interopDefault(import('../pages/_lang/aboutControl.js' /* webpackChunkName: "pages/_lang/aboutControl" */))
const _07fa1cc0 = () => interopDefault(import('../pages/_lang/cgs.vue' /* webpackChunkName: "pages/_lang/cgs" */))
const _8015495e = () => interopDefault(import('../pages/_lang/contact.vue' /* webpackChunkName: "pages/_lang/contact" */))
const _36f719af = () => interopDefault(import('../pages/_lang/contact/validity.js' /* webpackChunkName: "pages/_lang/contact/validity" */))
const _611e5cda = () => interopDefault(import('../pages/_lang/contactControl.js' /* webpackChunkName: "pages/_lang/contactControl" */))
const _70692b95 = () => interopDefault(import('../pages/_lang/draft/index.vue' /* webpackChunkName: "pages/_lang/draft/index" */))
const _6b4dd68c = () => interopDefault(import('../pages/_lang/fixture.vue' /* webpackChunkName: "pages/_lang/fixture" */))
const _95a87bf6 = () => interopDefault(import('../pages/_lang/indexControl.js' /* webpackChunkName: "pages/_lang/indexControl" */))
const _88e6beda = () => interopDefault(import('../pages/_lang/indexTags.js' /* webpackChunkName: "pages/_lang/indexTags" */))
const _04e248b8 = () => interopDefault(import('../pages/_lang/jobs/index.vue' /* webpackChunkName: "pages/_lang/jobs/index" */))
const _c8d587cc = () => interopDefault(import('../pages/_lang/parameter.vue' /* webpackChunkName: "pages/_lang/parameter" */))
const _0045bf6c = () => interopDefault(import('../pages/_lang/partners.vue' /* webpackChunkName: "pages/_lang/partners" */))
const _01359068 = () => interopDefault(import('../pages/_lang/partnersControl.js' /* webpackChunkName: "pages/_lang/partnersControl" */))
const _52fe7c9c = () => interopDefault(import('../pages/_lang/purge.vue' /* webpackChunkName: "pages/_lang/purge" */))
const _86f67690 = () => interopDefault(import('../pages/_lang/reset-password.vue' /* webpackChunkName: "pages/_lang/reset-password" */))
const _c8a15c8c = () => interopDefault(import('../pages/_lang/reset-passwordControl.js' /* webpackChunkName: "pages/_lang/reset-passwordControl" */))
const _7dc24a78 = () => interopDefault(import('../pages/_lang/sandbox.vue' /* webpackChunkName: "pages/_lang/sandbox" */))
const _04a1877a = () => interopDefault(import('../pages/_lang/sandboxControl.js' /* webpackChunkName: "pages/_lang/sandboxControl" */))
const _28fd42a3 = () => interopDefault(import('../pages/_lang/sentry_test.vue' /* webpackChunkName: "pages/_lang/sentry_test" */))
const _3740574f = () => interopDefault(import('../pages/_lang/storybook.vue' /* webpackChunkName: "pages/_lang/storybook" */))
const _772ab831 = () => interopDefault(import('../pages/_lang/test.vue' /* webpackChunkName: "pages/_lang/test" */))
const _85673cda = () => interopDefault(import('../pages/_lang/welcome.vue' /* webpackChunkName: "pages/_lang/welcome" */))
const _336759ef = () => interopDefault(import('../pages/_lang/agency/favorites/index.vue' /* webpackChunkName: "pages/_lang/agency/favorites/index" */))
const _55c17a19 = () => interopDefault(import('../pages/_lang/band/dashboard.vue' /* webpackChunkName: "pages/_lang/band/dashboard" */))
const _2b0cba5b = () => interopDefault(import('../pages/_lang/band/dashboardControl.js' /* webpackChunkName: "pages/_lang/band/dashboardControl" */))
const _36f953d8 = () => interopDefault(import('../pages/_lang/band/genres.js' /* webpackChunkName: "pages/_lang/band/genres" */))
const _680efa0e = () => interopDefault(import('../pages/_lang/band/homepage.vue' /* webpackChunkName: "pages/_lang/band/homepage" */))
const _0b46f772 = () => interopDefault(import('../pages/_lang/band/homepageAsyncData.js' /* webpackChunkName: "pages/_lang/band/homepageAsyncData" */))
const _3ef046e6 = () => interopDefault(import('../pages/_lang/band/homepageAsyncDataHandlers/index.js' /* webpackChunkName: "pages/_lang/band/homepageAsyncDataHandlers/index" */))
const _57519b3b = () => interopDefault(import('../pages/_lang/band/homepageControl.js' /* webpackChunkName: "pages/_lang/band/homepageControl" */))
const _022a431d = () => interopDefault(import('../pages/_lang/band/homepageTags.js' /* webpackChunkName: "pages/_lang/band/homepageTags" */))
const _09980c34 = () => interopDefault(import('../pages/_lang/band/onboarding.vue' /* webpackChunkName: "pages/_lang/band/onboarding" */))
const _68d0b0ae = () => interopDefault(import('../pages/_lang/band/parameter.vue' /* webpackChunkName: "pages/_lang/band/parameter" */))
const _5d4825a0 = () => interopDefault(import('../pages/_lang/band/parameterControl.js' /* webpackChunkName: "pages/_lang/band/parameterControl" */))
const _9b60055c = () => interopDefault(import('../pages/_lang/band/payin.vue' /* webpackChunkName: "pages/_lang/band/payin" */))
const _891b8c1e = () => interopDefault(import('../pages/_lang/band/profile/index.vue' /* webpackChunkName: "pages/_lang/band/profile/index" */))
const _3fd576c8 = () => interopDefault(import('../pages/_lang/band/sendtrack.vue' /* webpackChunkName: "pages/_lang/band/sendtrack" */))
const _72d3906c = () => interopDefault(import('../pages/_lang/band/sendtrackControl.js' /* webpackChunkName: "pages/_lang/band/sendtrackControl" */))
const _1fa288ee = () => interopDefault(import('../pages/_lang/band/sendtrackTags.js' /* webpackChunkName: "pages/_lang/band/sendtrackTags" */))
const _20b8c578 = () => interopDefault(import('../pages/_lang/band/shop/index.vue' /* webpackChunkName: "pages/_lang/band/shop/index" */))
const _4c16dfb4 = () => interopDefault(import('../pages/_lang/band/signup/index.vue' /* webpackChunkName: "pages/_lang/band/signup/index" */))
const _46d96f0e = () => interopDefault(import('../pages/_lang/draft/influencers.vue' /* webpackChunkName: "pages/_lang/draft/influencers" */))
const _4d9c95d6 = () => interopDefault(import('../pages/_lang/influencer/activate.vue' /* webpackChunkName: "pages/_lang/influencer/activate" */))
const _2e3d5750 = () => interopDefault(import('../pages/_lang/influencer/activateControl.js' /* webpackChunkName: "pages/_lang/influencer/activateControl" */))
const _84fe89b0 = () => interopDefault(import('../pages/_lang/influencer/cashout.vue' /* webpackChunkName: "pages/_lang/influencer/cashout" */))
const _1614b42a = () => interopDefault(import('../pages/_lang/influencer/cashoutControl.js' /* webpackChunkName: "pages/_lang/influencer/cashoutControl" */))
const _4453267e = () => interopDefault(import('../pages/_lang/influencer/dashboard.vue' /* webpackChunkName: "pages/_lang/influencer/dashboard" */))
const _a189e1fa = () => interopDefault(import('../pages/_lang/influencer/dashboardControl.js' /* webpackChunkName: "pages/_lang/influencer/dashboardControl" */))
const _1e34b954 = () => interopDefault(import('../pages/_lang/influencer/parameter.vue' /* webpackChunkName: "pages/_lang/influencer/parameter" */))
const _558a41d8 = () => interopDefault(import('../pages/_lang/influencer/parameterControl.js' /* webpackChunkName: "pages/_lang/influencer/parameterControl" */))
const _74fd9899 = () => interopDefault(import('../pages/_lang/influencer/profile/index.vue' /* webpackChunkName: "pages/_lang/influencer/profile/index" */))
const _50a28704 = () => interopDefault(import('../pages/_lang/influencer/signup/index.vue' /* webpackChunkName: "pages/_lang/influencer/signup/index" */))
const _0b401eaa = () => interopDefault(import('../pages/_lang/influencer/widget/index.vue' /* webpackChunkName: "pages/_lang/influencer/widget/index" */))
const _20d9d5ba = () => interopDefault(import('../pages/_lang/jobs/indexControl.js' /* webpackChunkName: "pages/_lang/jobs/indexControl" */))
const _0e8530fe = () => interopDefault(import('../pages/_lang/jobs/indexTags.js' /* webpackChunkName: "pages/_lang/jobs/indexTags" */))
const _a4ed5c8e = () => interopDefault(import('../pages/_lang/payin/failure.vue' /* webpackChunkName: "pages/_lang/payin/failure" */))
const _85874c0a = () => interopDefault(import('../pages/_lang/payin/failureControl.js' /* webpackChunkName: "pages/_lang/payin/failureControl" */))
const _29dd1318 = () => interopDefault(import('../pages/_lang/signup/discovery.vue' /* webpackChunkName: "pages/_lang/signup/discovery" */))
const _b9294fcc = () => interopDefault(import('../pages/_lang/signup/discoveryControl.js' /* webpackChunkName: "pages/_lang/signup/discoveryControl" */))
const _3f04e1b1 = () => interopDefault(import('../pages/_lang/agency/favorites/indexControl.js' /* webpackChunkName: "pages/_lang/agency/favorites/indexControl" */))
const _1c4b6117 = () => interopDefault(import('../pages/_lang/band/homepageAsyncDataHandlers/contests.js' /* webpackChunkName: "pages/_lang/band/homepageAsyncDataHandlers/contests" */))
const _87a13a38 = () => interopDefault(import('../pages/_lang/band/homepageAsyncDataHandlers/drafts.js' /* webpackChunkName: "pages/_lang/band/homepageAsyncDataHandlers/drafts" */))
const _3d342716 = () => interopDefault(import('../pages/_lang/band/homepageAsyncDataHandlers/fans.js' /* webpackChunkName: "pages/_lang/band/homepageAsyncDataHandlers/fans" */))
const _50610fe5 = () => interopDefault(import('../pages/_lang/band/homepageAsyncDataHandlers/faqArticles.js' /* webpackChunkName: "pages/_lang/band/homepageAsyncDataHandlers/faqArticles" */))
const _3534fae8 = () => interopDefault(import('../pages/_lang/band/homepageAsyncDataHandlers/infCount.js' /* webpackChunkName: "pages/_lang/band/homepageAsyncDataHandlers/infCount" */))
const _73ea9a20 = () => interopDefault(import('../pages/_lang/band/homepageAsyncDataHandlers/newInfluencers.js' /* webpackChunkName: "pages/_lang/band/homepageAsyncDataHandlers/newInfluencers" */))
const _650e0ecb = () => interopDefault(import('../pages/_lang/band/homepageAsyncDataHandlers/partners.js' /* webpackChunkName: "pages/_lang/band/homepageAsyncDataHandlers/partners" */))
const _6ff11911 = () => interopDefault(import('../pages/_lang/band/homepageAsyncDataHandlers/popInfluencers.js' /* webpackChunkName: "pages/_lang/band/homepageAsyncDataHandlers/popInfluencers" */))
const _65688845 = () => interopDefault(import('../pages/_lang/band/homepageAsyncDataHandlers/posts.js' /* webpackChunkName: "pages/_lang/band/homepageAsyncDataHandlers/posts" */))
const _35b94974 = () => interopDefault(import('../pages/_lang/band/homepageAsyncDataHandlers/successStories.js' /* webpackChunkName: "pages/_lang/band/homepageAsyncDataHandlers/successStories" */))
const _4aed6226 = () => interopDefault(import('../pages/_lang/band/profile/create.vue' /* webpackChunkName: "pages/_lang/band/profile/create" */))
const _364ea02f = () => interopDefault(import('../pages/_lang/band/profile/createControl.js' /* webpackChunkName: "pages/_lang/band/profile/createControl" */))
const _1bcb77c8 = () => interopDefault(import('../pages/_lang/band/profile/delete.vue' /* webpackChunkName: "pages/_lang/band/profile/delete" */))
const _6ed8b61e = () => interopDefault(import('../pages/_lang/band/profile/deleteControl.js' /* webpackChunkName: "pages/_lang/band/profile/deleteControl" */))
const _2638e2ed = () => interopDefault(import('../pages/_lang/band/profile/select.vue' /* webpackChunkName: "pages/_lang/band/profile/select" */))
const _5bd13510 = () => interopDefault(import('../pages/_lang/band/shop/finalized.vue' /* webpackChunkName: "pages/_lang/band/shop/finalized" */))
const _2ac51004 = () => interopDefault(import('../pages/_lang/band/signup/discovery.vue' /* webpackChunkName: "pages/_lang/band/signup/discovery" */))
const _68ab8ad0 = () => interopDefault(import('../pages/_lang/band/signup/indexTags.js' /* webpackChunkName: "pages/_lang/band/signup/indexTags" */))
const _76a74f56 = () => interopDefault(import('../pages/_lang/influencer/list/all/index.vue' /* webpackChunkName: "pages/_lang/influencer/list/all/index" */))
const _673f3384 = () => interopDefault(import('../pages/_lang/influencer/list/fans.vue' /* webpackChunkName: "pages/_lang/influencer/list/fans" */))
const _1ae68625 = () => interopDefault(import('../pages/_lang/influencer/list/new-arrivals.vue' /* webpackChunkName: "pages/_lang/influencer/list/new-arrivals" */))
const _5703834b = () => interopDefault(import('../pages/_lang/influencer/list/popular.vue' /* webpackChunkName: "pages/_lang/influencer/list/popular" */))
const _68e01954 = () => interopDefault(import('../pages/_lang/influencer/list/shared_computed.js' /* webpackChunkName: "pages/_lang/influencer/list/shared_computed" */))
const _25485cf1 = () => interopDefault(import('../pages/_lang/influencer/list/shared_fetch.js' /* webpackChunkName: "pages/_lang/influencer/list/shared_fetch" */))
const _0155dd00 = () => interopDefault(import('../pages/_lang/influencer/signup/indexControl.js' /* webpackChunkName: "pages/_lang/influencer/signup/indexControl" */))
const _fcbb1b5c = () => interopDefault(import('../pages/_lang/influencer/signup/tags.js' /* webpackChunkName: "pages/_lang/influencer/signup/tags" */))
const _417454ed = () => interopDefault(import('../pages/_lang/payin/paypal/retry.vue' /* webpackChunkName: "pages/_lang/payin/paypal/retry" */))
const _4c851412 = () => interopDefault(import('../pages/_lang/spotify/share/track.vue' /* webpackChunkName: "pages/_lang/spotify/share/track" */))
const _3c3fe720 = () => interopDefault(import('../pages/_lang/spotify/share/trackAsyncData.js' /* webpackChunkName: "pages/_lang/spotify/share/trackAsyncData" */))
const _b8dde7d2 = () => interopDefault(import('../pages/_lang/agency/favorites/_id.vue' /* webpackChunkName: "pages/_lang/agency/favorites/_id" */))
const _f4cb544e = () => interopDefault(import('../pages/_lang/agency/favorites/_idControl.js' /* webpackChunkName: "pages/_lang/agency/favorites/_idControl" */))
const _17198728 = () => interopDefault(import('../pages/_lang/band/profile/_slug/index.vue' /* webpackChunkName: "pages/_lang/band/profile/_slug/index" */))
const _5a96fd14 = () => interopDefault(import('../pages/_lang/influencer/profile/_slug/index.vue' /* webpackChunkName: "pages/_lang/influencer/profile/_slug/index" */))
const _09897d62 = () => interopDefault(import('../pages/_lang/influencer/widget/_slug.vue' /* webpackChunkName: "pages/_lang/influencer/widget/_slug" */))
const _9da53a38 = () => interopDefault(import('../pages/_lang/influencer/widget/_slugControl.js' /* webpackChunkName: "pages/_lang/influencer/widget/_slugControl" */))
const _470cad40 = () => interopDefault(import('../pages/_lang/band/profile/_slug/edit.vue' /* webpackChunkName: "pages/_lang/band/profile/_slug/edit" */))
const _8effcf3c = () => interopDefault(import('../pages/_lang/band/profile/_slug/editControl.js' /* webpackChunkName: "pages/_lang/band/profile/_slug/editControl" */))
const _3eeb9b24 = () => interopDefault(import('../pages/_lang/band/profile/_slug/indexControl.js' /* webpackChunkName: "pages/_lang/band/profile/_slug/indexControl" */))
const _b07bd480 = () => interopDefault(import('../pages/_lang/band/profile/_slug/tags.js' /* webpackChunkName: "pages/_lang/band/profile/_slug/tags" */))
const _2ff19890 = () => interopDefault(import('../pages/_lang/influencer/profile/_slug/edit.vue' /* webpackChunkName: "pages/_lang/influencer/profile/_slug/edit" */))
const _716280ba = () => interopDefault(import('../pages/_lang/influencer/profile/_slug/editControl.js' /* webpackChunkName: "pages/_lang/influencer/profile/_slug/editControl" */))
const _43f4d516 = () => interopDefault(import('../pages/_lang/influencer/profile/_slug/indexControl.js' /* webpackChunkName: "pages/_lang/influencer/profile/_slug/indexControl" */))
const _9a936aec = () => interopDefault(import('../pages/_lang/influencer/profile/_slug/preview.vue' /* webpackChunkName: "pages/_lang/influencer/profile/_slug/preview" */))
const _0d4dab52 = () => interopDefault(import('../pages/_lang/influencer/profile/_slug/sharedSlugAsyncData.js' /* webpackChunkName: "pages/_lang/influencer/profile/_slug/sharedSlugAsyncData" */))
const _4ca43f30 = () => interopDefault(import('../pages/_lang/influencer/profile/_slug/tags.js' /* webpackChunkName: "pages/_lang/influencer/profile/_slug/tags" */))
const _1e2f1800 = () => interopDefault(import('../pages/_lang/draft/_id/index.vue' /* webpackChunkName: "pages/_lang/draft/_id/index" */))
const _3f5b1920 = () => interopDefault(import('../pages/_lang/jobs/_id.vue' /* webpackChunkName: "pages/_lang/jobs/_id" */))
const _582e82b7 = () => interopDefault(import('../pages/_lang/jobs/_id/tags.js' /* webpackChunkName: "pages/_lang/jobs/_id/tags" */))
const _2ab4cf04 = () => interopDefault(import('../pages/_lang/jobs/_id/validity.js' /* webpackChunkName: "pages/_lang/jobs/_id/validity" */))
const _2efeb822 = () => interopDefault(import('../pages/_lang/jobs/_idControl.js' /* webpackChunkName: "pages/_lang/jobs/_idControl" */))
const _635a7e34 = () => interopDefault(import('../pages/_lang/draft/_id/finalized.vue' /* webpackChunkName: "pages/_lang/draft/_id/finalized" */))
const _079a5fb2 = () => interopDefault(import('../pages/_lang/draft/_id/influencers/index.vue' /* webpackChunkName: "pages/_lang/draft/_id/influencers/index" */))
const _5e6d6c8e = () => interopDefault(import('../pages/_lang/draft/_id/messages.vue' /* webpackChunkName: "pages/_lang/draft/_id/messages" */))
const _3f276510 = () => interopDefault(import('../pages/_lang/draft/_id/post3ds.vue' /* webpackChunkName: "pages/_lang/draft/_id/post3ds" */))
const _443b6d6d = () => interopDefault(import('../pages/_lang/draft/_id/recap.vue' /* webpackChunkName: "pages/_lang/draft/_id/recap" */))
const _519fd68c = () => interopDefault(import('../pages/_lang/draft/_id/selection.vue' /* webpackChunkName: "pages/_lang/draft/_id/selection" */))
const _4c8a57f9 = () => interopDefault(import('../pages/_lang/draft/_id/track.vue' /* webpackChunkName: "pages/_lang/draft/_id/track" */))
const _c8646f5e = () => interopDefault(import('../pages/_lang/draft/_id/influencers/loading.vue' /* webpackChunkName: "pages/_lang/draft/_id/influencers/loading" */))
const _250c1aea = () => interopDefault(import('../pages/_lang/draft/_id/favorites/_bucket_id.vue' /* webpackChunkName: "pages/_lang/draft/_id/favorites/_bucket_id" */))

// TODO: remove in Nuxt 3
const emptyFn = () => {}
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onComplete = emptyFn, onAbort) {
  return originalPush.call(this, location, onComplete, onAbort)
}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: decodeURI('/'),
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/about",
    component: _6a3c0b80,
    name: "about"
  }, {
    path: "/cgs",
    component: _ff395b7c,
    name: "cgs"
  }, {
    path: "/contact",
    component: _6438005a,
    name: "contact"
  }, {
    path: "/draft",
    component: _34e481d2,
    name: "draft"
  }, {
    path: "/fixture",
    component: _4f708d88,
    name: "fixture"
  }, {
    path: "/jobs",
    component: _52fc3cf6,
    name: "jobs"
  }, {
    path: "/parameter",
    component: _2f266fc8,
    name: "parameter"
  }, {
    path: "/partners",
    component: _a079e7f0,
    name: "partners"
  }, {
    path: "/purge",
    component: _55f0599e,
    name: "purge"
  }, {
    path: "/reset-password",
    component: _70232c14,
    name: "reset-password"
  }, {
    path: "/sandbox",
    component: _e89e220c,
    name: "sandbox"
  }, {
    path: "/storybook",
    component: _f7d0395e,
    name: "storybook"
  }, {
    path: "/test",
    component: _0be832ef,
    name: "test"
  }, {
    path: "/welcome",
    component: _6989f3d6,
    name: "welcome"
  }, {
    path: "/agency/favorites",
    component: _6c223da6,
    name: "agency-favorites"
  }, {
    path: "/band/dashboard",
    component: _612b1f57,
    name: "band-dashboard"
  }, {
    path: "/band/homepage",
    component: _eb73840a,
    name: "band-homepage"
  }, {
    path: "/band/onboarding",
    component: _5cfefc68,
    name: "band-onboarding"
  }, {
    path: "/band/parameter",
    component: _743a55ec,
    name: "band-parameter"
  }, {
    path: "/band/payin",
    component: _0069f190,
    name: "band-payin"
  }, {
    path: "/band/profile",
    component: _02eb102f,
    name: "band-profile"
  }, {
    path: "/band/sendtrack",
    component: _4b3f1c06,
    name: "band-sendtrack"
  }, {
    path: "/band/shop",
    component: _516e9fc6,
    name: "band-shop"
  }, {
    path: "/band/signup",
    component: _15ee0bb0,
    name: "band-signup"
  }, {
    path: "/draft/influencers",
    component: _10b09b0a,
    name: "draft-influencers"
  }, {
    path: "/influencer/activate",
    component: _1582f150,
    name: "influencer-activate"
  }, {
    path: "/influencer/cashout",
    component: _04f99166,
    name: "influencer-cashout"
  }, {
    path: "/influencer/dashboard",
    component: _2a72ab7f,
    name: "influencer-dashboard"
  }, {
    path: "/influencer/parameter",
    component: _3d81e214,
    name: "influencer-parameter"
  }, {
    path: "/influencer/profile",
    component: _f07f6f52,
    name: "influencer-profile"
  }, {
    path: "/influencer/signup",
    component: _12181d00,
    name: "influencer-signup"
  }, {
    path: "/influencer/widget",
    component: _45a97f2c,
    name: "influencer-widget"
  }, {
    path: "/payin/failure",
    component: _6bd70cbb,
    name: "payin-failure"
  }, {
    path: "/band/profile/create",
    component: _fba97f22,
    name: "band-profile-create"
  }, {
    path: "/band/profile/select",
    component: _644a5722,
    name: "band-profile-select"
  }, {
    path: "/band/shop/finalized",
    component: _79b956fa,
    name: "band-shop-finalized"
  }, {
    path: "/band/signup/discovery",
    component: _71b0a906,
    name: "band-signup-discovery"
  }, {
    path: "/influencer/list/all",
    component: _878ad150,
    name: "influencer-list-all"
  }, {
    path: "/influencer/list/fans",
    component: _18fca4fc,
    name: "influencer-list-fans"
  }, {
    path: "/influencer/list/new-arrivals",
    component: _ada1b23a,
    name: "influencer-list-new-arrivals"
  }, {
    path: "/influencer/list/popular",
    component: _dd263866,
    name: "influencer-list-popular"
  }, {
    path: "/payin/paypal/retry",
    component: _ee25a9aa,
    name: "payin-paypal-retry"
  }, {
    path: "/spotify/share/track",
    component: _fd41310e,
    name: "spotify-share-track"
  }, {
    path: "/agency/favorites/:id",
    component: _1fa56a56,
    name: "agency-favorites-id"
  }, {
    path: "/band/profile/:slug",
    component: _0735ec2a,
    name: "band-profile-slug"
  }, {
    path: "/influencer/profile/:slug",
    component: _793a6652,
    name: "influencer-profile-slug"
  }, {
    path: "/influencer/widget/:slug",
    component: _43f2dde4,
    name: "influencer-widget-slug"
  }, {
    path: "/band/profile/:slug/edit",
    component: _16e309e2,
    name: "band-profile-slug-edit"
  }, {
    path: "/influencer/profile/:slug/edit",
    component: _22d2aaba,
    name: "influencer-profile-slug-edit"
  }, {
    path: "/influencer/profile/:slug/preview",
    component: _93b74770,
    name: "influencer-profile-slug-preview"
  }, {
    path: "/draft/:id",
    component: _52b37682,
    name: "draft-id"
  }, {
    path: "/jobs/:id",
    component: _217df644,
    name: "jobs-id"
  }, {
    path: "/draft/:id/finalized",
    component: _0afc6fb6,
    name: "draft-id-finalized"
  }, {
    path: "/draft/:id/influencers",
    component: _2a141fa9,
    name: "draft-id-influencers"
  }, {
    path: "/draft/:id/messages",
    component: _b4337a68,
    name: "draft-id-messages"
  }, {
    path: "/draft/:id/post3ds",
    component: _5a3bcf12,
    name: "draft-id-post3ds"
  }, {
    path: "/draft/:id/recap",
    component: _b3f32022,
    name: "draft-id-recap"
  }, {
    path: "/draft/:id/selection",
    component: _7ed2063c,
    name: "draft-id-selection"
  }, {
    path: "/draft/:id/track",
    component: _a3554b0a,
    name: "draft-id-track"
  }, {
    path: "/draft/:id/influencers/loading",
    component: _52cd815a,
    name: "draft-id-influencers-loading"
  }, {
    path: "/draft/:id/favorites/:bucket_id?",
    component: _0c1d5bc9,
    name: "draft-id-favorites-bucket_id"
  }, {
    path: "/",
    component: _ec183376,
    name: "index"
  }, {
    path: "/:lang",
    component: _f1fbed7a,
    name: "lang"
  }, {
    path: "/:lang/about",
    component: _674a2e7e,
    name: "lang-about"
  }, {
    path: "/:lang/aboutControl",
    component: _91d86200,
    name: "lang-aboutControl"
  }, {
    path: "/:lang/cgs",
    component: _07fa1cc0,
    name: "lang-cgs"
  }, {
    path: "/:lang/contact",
    component: _8015495e,
    name: "lang-contact",
    children: [{
      path: "validity",
      component: _36f719af,
      name: "lang-contact-validity"
    }]
  }, {
    path: "/:lang/contactControl",
    component: _611e5cda,
    name: "lang-contactControl"
  }, {
    path: "/:lang/draft",
    component: _70692b95,
    name: "lang-draft"
  }, {
    path: "/:lang/fixture",
    component: _6b4dd68c,
    name: "lang-fixture"
  }, {
    path: "/:lang/indexControl",
    component: _95a87bf6,
    name: "lang-indexControl"
  }, {
    path: "/:lang/indexTags",
    component: _88e6beda,
    name: "lang-indexTags"
  }, {
    path: "/:lang/jobs",
    component: _04e248b8,
    name: "lang-jobs"
  }, {
    path: "/:lang/parameter",
    component: _c8d587cc,
    name: "lang-parameter"
  }, {
    path: "/:lang/partners",
    component: _0045bf6c,
    name: "lang-partners"
  }, {
    path: "/:lang/partnersControl",
    component: _01359068,
    name: "lang-partnersControl"
  }, {
    path: "/:lang/purge",
    component: _52fe7c9c,
    name: "lang-purge"
  }, {
    path: "/:lang/reset-password",
    component: _86f67690,
    name: "lang-reset-password"
  }, {
    path: "/:lang/reset-passwordControl",
    component: _c8a15c8c,
    name: "lang-reset-passwordControl"
  }, {
    path: "/:lang/sandbox",
    component: _7dc24a78,
    name: "lang-sandbox"
  }, {
    path: "/:lang/sandboxControl",
    component: _04a1877a,
    name: "lang-sandboxControl"
  }, {
    path: "/:lang/sentry_test",
    component: _28fd42a3,
    name: "lang-sentry_test"
  }, {
    path: "/:lang/storybook",
    component: _3740574f,
    name: "lang-storybook"
  }, {
    path: "/:lang/test",
    component: _772ab831,
    name: "lang-test"
  }, {
    path: "/:lang/welcome",
    component: _85673cda,
    name: "lang-welcome"
  }, {
    path: "/:lang/agency/favorites",
    component: _336759ef,
    name: "lang-agency-favorites"
  }, {
    path: "/:lang/band/dashboard",
    component: _55c17a19,
    name: "lang-band-dashboard"
  }, {
    path: "/:lang/band/dashboardControl",
    component: _2b0cba5b,
    name: "lang-band-dashboardControl"
  }, {
    path: "/:lang/band/genres",
    component: _36f953d8,
    name: "lang-band-genres"
  }, {
    path: "/:lang/band/homepage",
    component: _680efa0e,
    name: "lang-band-homepage"
  }, {
    path: "/:lang/band/homepageAsyncData",
    component: _0b46f772,
    name: "lang-band-homepageAsyncData"
  }, {
    path: "/:lang/band/homepageAsyncDataHandlers",
    component: _3ef046e6,
    name: "lang-band-homepageAsyncDataHandlers"
  }, {
    path: "/:lang/band/homepageControl",
    component: _57519b3b,
    name: "lang-band-homepageControl"
  }, {
    path: "/:lang/band/homepageTags",
    component: _022a431d,
    name: "lang-band-homepageTags"
  }, {
    path: "/:lang/band/onboarding",
    component: _09980c34,
    name: "lang-band-onboarding"
  }, {
    path: "/:lang/band/parameter",
    component: _68d0b0ae,
    name: "lang-band-parameter"
  }, {
    path: "/:lang/band/parameterControl",
    component: _5d4825a0,
    name: "lang-band-parameterControl"
  }, {
    path: "/:lang/band/payin",
    component: _9b60055c,
    name: "lang-band-payin"
  }, {
    path: "/:lang/band/profile",
    component: _891b8c1e,
    name: "lang-band-profile"
  }, {
    path: "/:lang/band/sendtrack",
    component: _3fd576c8,
    name: "lang-band-sendtrack"
  }, {
    path: "/:lang/band/sendtrackControl",
    component: _72d3906c,
    name: "lang-band-sendtrackControl"
  }, {
    path: "/:lang/band/sendtrackTags",
    component: _1fa288ee,
    name: "lang-band-sendtrackTags"
  }, {
    path: "/:lang/band/shop",
    component: _20b8c578,
    name: "lang-band-shop"
  }, {
    path: "/:lang/band/signup",
    component: _4c16dfb4,
    name: "lang-band-signup"
  }, {
    path: "/:lang/draft/influencers",
    component: _46d96f0e,
    name: "lang-draft-influencers"
  }, {
    path: "/:lang/influencer/activate",
    component: _4d9c95d6,
    name: "lang-influencer-activate"
  }, {
    path: "/:lang/influencer/activateControl",
    component: _2e3d5750,
    name: "lang-influencer-activateControl"
  }, {
    path: "/:lang/influencer/cashout",
    component: _84fe89b0,
    name: "lang-influencer-cashout"
  }, {
    path: "/:lang/influencer/cashoutControl",
    component: _1614b42a,
    name: "lang-influencer-cashoutControl"
  }, {
    path: "/:lang/influencer/dashboard",
    component: _4453267e,
    name: "lang-influencer-dashboard"
  }, {
    path: "/:lang/influencer/dashboardControl",
    component: _a189e1fa,
    name: "lang-influencer-dashboardControl"
  }, {
    path: "/:lang/influencer/parameter",
    component: _1e34b954,
    name: "lang-influencer-parameter"
  }, {
    path: "/:lang/influencer/parameterControl",
    component: _558a41d8,
    name: "lang-influencer-parameterControl"
  }, {
    path: "/:lang/influencer/profile",
    component: _74fd9899,
    name: "lang-influencer-profile"
  }, {
    path: "/:lang/influencer/signup",
    component: _50a28704,
    name: "lang-influencer-signup"
  }, {
    path: "/:lang/influencer/widget",
    component: _0b401eaa,
    name: "lang-influencer-widget"
  }, {
    path: "/:lang/jobs/indexControl",
    component: _20d9d5ba,
    name: "lang-jobs-indexControl"
  }, {
    path: "/:lang/jobs/indexTags",
    component: _0e8530fe,
    name: "lang-jobs-indexTags"
  }, {
    path: "/:lang/payin/failure",
    component: _a4ed5c8e,
    name: "lang-payin-failure"
  }, {
    path: "/:lang/payin/failureControl",
    component: _85874c0a,
    name: "lang-payin-failureControl"
  }, {
    path: "/:lang/signup/discovery",
    component: _29dd1318,
    name: "lang-signup-discovery"
  }, {
    path: "/:lang/signup/discoveryControl",
    component: _b9294fcc,
    name: "lang-signup-discoveryControl"
  }, {
    path: "/:lang/agency/favorites/indexControl",
    component: _3f04e1b1,
    name: "lang-agency-favorites-indexControl"
  }, {
    path: "/:lang/band/homepageAsyncDataHandlers/contests",
    component: _1c4b6117,
    name: "lang-band-homepageAsyncDataHandlers-contests"
  }, {
    path: "/:lang/band/homepageAsyncDataHandlers/drafts",
    component: _87a13a38,
    name: "lang-band-homepageAsyncDataHandlers-drafts"
  }, {
    path: "/:lang/band/homepageAsyncDataHandlers/fans",
    component: _3d342716,
    name: "lang-band-homepageAsyncDataHandlers-fans"
  }, {
    path: "/:lang/band/homepageAsyncDataHandlers/faqArticles",
    component: _50610fe5,
    name: "lang-band-homepageAsyncDataHandlers-faqArticles"
  }, {
    path: "/:lang/band/homepageAsyncDataHandlers/infCount",
    component: _3534fae8,
    name: "lang-band-homepageAsyncDataHandlers-infCount"
  }, {
    path: "/:lang/band/homepageAsyncDataHandlers/newInfluencers",
    component: _73ea9a20,
    name: "lang-band-homepageAsyncDataHandlers-newInfluencers"
  }, {
    path: "/:lang/band/homepageAsyncDataHandlers/partners",
    component: _650e0ecb,
    name: "lang-band-homepageAsyncDataHandlers-partners"
  }, {
    path: "/:lang/band/homepageAsyncDataHandlers/popInfluencers",
    component: _6ff11911,
    name: "lang-band-homepageAsyncDataHandlers-popInfluencers"
  }, {
    path: "/:lang/band/homepageAsyncDataHandlers/posts",
    component: _65688845,
    name: "lang-band-homepageAsyncDataHandlers-posts"
  }, {
    path: "/:lang/band/homepageAsyncDataHandlers/successStories",
    component: _35b94974,
    name: "lang-band-homepageAsyncDataHandlers-successStories"
  }, {
    path: "/:lang/band/profile/create",
    component: _4aed6226,
    name: "lang-band-profile-create"
  }, {
    path: "/:lang/band/profile/createControl",
    component: _364ea02f,
    name: "lang-band-profile-createControl"
  }, {
    path: "/:lang/band/profile/delete",
    component: _1bcb77c8,
    name: "lang-band-profile-delete"
  }, {
    path: "/:lang/band/profile/deleteControl",
    component: _6ed8b61e,
    name: "lang-band-profile-deleteControl"
  }, {
    path: "/:lang/band/profile/select",
    component: _2638e2ed,
    name: "lang-band-profile-select"
  }, {
    path: "/:lang/band/shop/finalized",
    component: _5bd13510,
    name: "lang-band-shop-finalized"
  }, {
    path: "/:lang/band/signup/discovery",
    component: _2ac51004,
    name: "lang-band-signup-discovery"
  }, {
    path: "/:lang/band/signup/indexTags",
    component: _68ab8ad0,
    name: "lang-band-signup-indexTags"
  }, {
    path: "/:lang/influencer/list/all",
    component: _76a74f56,
    name: "lang-influencer-list-all"
  }, {
    path: "/:lang/influencer/list/fans",
    component: _673f3384,
    name: "lang-influencer-list-fans"
  }, {
    path: "/:lang/influencer/list/new-arrivals",
    component: _1ae68625,
    name: "lang-influencer-list-new-arrivals"
  }, {
    path: "/:lang/influencer/list/popular",
    component: _5703834b,
    name: "lang-influencer-list-popular"
  }, {
    path: "/:lang/influencer/list/shared_computed",
    component: _68e01954,
    name: "lang-influencer-list-shared_computed"
  }, {
    path: "/:lang/influencer/list/shared_fetch",
    component: _25485cf1,
    name: "lang-influencer-list-shared_fetch"
  }, {
    path: "/:lang/influencer/signup/indexControl",
    component: _0155dd00,
    name: "lang-influencer-signup-indexControl"
  }, {
    path: "/:lang/influencer/signup/tags",
    component: _fcbb1b5c,
    name: "lang-influencer-signup-tags"
  }, {
    path: "/:lang/payin/paypal/retry",
    component: _417454ed,
    name: "lang-payin-paypal-retry"
  }, {
    path: "/:lang/spotify/share/track",
    component: _4c851412,
    name: "lang-spotify-share-track"
  }, {
    path: "/:lang/spotify/share/trackAsyncData",
    component: _3c3fe720,
    name: "lang-spotify-share-trackAsyncData"
  }, {
    path: "/:lang/agency/favorites/:id",
    component: _b8dde7d2,
    name: "lang-agency-favorites-id"
  }, {
    path: "/:lang/agency/favorites/:idControl",
    component: _f4cb544e,
    name: "lang-agency-favorites-idControl"
  }, {
    path: "/:lang/band/profile/:slug",
    component: _17198728,
    name: "lang-band-profile-slug"
  }, {
    path: "/:lang/influencer/profile/:slug",
    component: _5a96fd14,
    name: "lang-influencer-profile-slug"
  }, {
    path: "/:lang/influencer/widget/:slug",
    component: _09897d62,
    name: "lang-influencer-widget-slug"
  }, {
    path: "/:lang/influencer/widget/:slugControl",
    component: _9da53a38,
    name: "lang-influencer-widget-slugControl"
  }, {
    path: "/:lang/band/profile/:slug/edit",
    component: _470cad40,
    name: "lang-band-profile-slug-edit"
  }, {
    path: "/:lang/band/profile/:slug/editControl",
    component: _8effcf3c,
    name: "lang-band-profile-slug-editControl"
  }, {
    path: "/:lang/band/profile/:slug/indexControl",
    component: _3eeb9b24,
    name: "lang-band-profile-slug-indexControl"
  }, {
    path: "/:lang/band/profile/:slug/tags",
    component: _b07bd480,
    name: "lang-band-profile-slug-tags"
  }, {
    path: "/:lang/influencer/profile/:slug/edit",
    component: _2ff19890,
    name: "lang-influencer-profile-slug-edit"
  }, {
    path: "/:lang/influencer/profile/:slug/editControl",
    component: _716280ba,
    name: "lang-influencer-profile-slug-editControl"
  }, {
    path: "/:lang/influencer/profile/:slug/indexControl",
    component: _43f4d516,
    name: "lang-influencer-profile-slug-indexControl"
  }, {
    path: "/:lang/influencer/profile/:slug/preview",
    component: _9a936aec,
    name: "lang-influencer-profile-slug-preview"
  }, {
    path: "/:lang/influencer/profile/:slug/sharedSlugAsyncData",
    component: _0d4dab52,
    name: "lang-influencer-profile-slug-sharedSlugAsyncData"
  }, {
    path: "/:lang/influencer/profile/:slug/tags",
    component: _4ca43f30,
    name: "lang-influencer-profile-slug-tags"
  }, {
    path: "/:lang/draft/:id",
    component: _1e2f1800,
    name: "lang-draft-id"
  }, {
    path: "/:lang/jobs/:id",
    component: _3f5b1920,
    name: "lang-jobs-id",
    children: [{
      path: "tags",
      component: _582e82b7,
      name: "lang-jobs-id-tags"
    }, {
      path: "validity",
      component: _2ab4cf04,
      name: "lang-jobs-id-validity"
    }]
  }, {
    path: "/:lang/jobs/:idControl",
    component: _2efeb822,
    name: "lang-jobs-idControl"
  }, {
    path: "/:lang/draft/:id/finalized",
    component: _635a7e34,
    name: "lang-draft-id-finalized"
  }, {
    path: "/:lang/draft/:id/influencers",
    component: _079a5fb2,
    name: "lang-draft-id-influencers"
  }, {
    path: "/:lang/draft/:id/messages",
    component: _5e6d6c8e,
    name: "lang-draft-id-messages"
  }, {
    path: "/:lang/draft/:id/post3ds",
    component: _3f276510,
    name: "lang-draft-id-post3ds"
  }, {
    path: "/:lang/draft/:id/recap",
    component: _443b6d6d,
    name: "lang-draft-id-recap"
  }, {
    path: "/:lang/draft/:id/selection",
    component: _519fd68c,
    name: "lang-draft-id-selection"
  }, {
    path: "/:lang/draft/:id/track",
    component: _4c8a57f9,
    name: "lang-draft-id-track"
  }, {
    path: "/:lang/draft/:id/influencers/loading",
    component: _c8646f5e,
    name: "lang-draft-id-influencers-loading"
  }, {
    path: "/:lang/draft/:id/favorites/:bucket_id?",
    component: _250c1aea,
    name: "lang-draft-id-favorites-bucket_id"
  }],

  fallback: false
}

export function createRouter () {
  return new Router(routerOptions)
}
